import { render, staticRenderFns } from "./saveTopPlaysTable.vue?vue&type=template&id=2da38610&scoped=true"
import script from "./saveTopPlaysTable.vue?vue&type=script&lang=js"
export * from "./saveTopPlaysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da38610",
  null
  
)

export default component.exports